export default __webpack_public_path__ + "540d911a07df8c74ada4ed19a205d7cf.svg";